// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52775ed2","453":"feff72ad","455":"fe366785","977":"60fcc770"}[chunkId] + ".chunk.js";
};